module.exports = __webpack_public_path__ + "static/media/nugugif2.90a48481.gif";